import { render, staticRenderFns } from "./FormulaPage.vue?vue&type=template&id=6e019ad0"
import script from "./FormulaPage.js?vue&type=script&lang=js&external"
export * from "./FormulaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports